
import HttpClientToken from '../../services/HttpClientToken';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, ActualizarSentenciaPublicaParams, defaultActualizarEstatus, defaultNuevaSentenciaPublica, defaultSentenciaPublica, NuevaSentenciaPublicaParams, NuevaSentenciaPublicaResponse, DetalleSentenciaPublicaResponse } from '../../interfaces/sentencia/SentenciaPublicaInterface';

export const NuevaSentenciaPublica = ( params: NuevaSentenciaPublicaParams ) => {

    return new Promise<NuevaSentenciaPublicaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentenciaPublica/NuevaSentenciaPublica', params, token)
            .then( ({ data } : { data : NuevaSentenciaPublicaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNuevaSentenciaPublica, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const DetalleSentenciaPublica = ( Id: string ) => {

    return new Promise<DetalleSentenciaPublicaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/SentenciaPublica/DetalleSentenciaPublica/${Id}`, token)
            .then( ({ data } : { data : DetalleSentenciaPublicaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultSentenciaPublica, success: false, message: 'Ocurrio un error contacte con el administrador' });
            });

        }

    });

}

export const GuardarSentenciaPublica = ( params: ActualizarSentenciaPublicaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentenciaPublica/GuardarSentenciaPublica/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const ActualizarEstatusSentenciaPublica = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentenciaPublica/ActualizarEstatus/', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultActualizarEstatus, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}
